<script setup lang="ts">
import ContactSection from '../components/ContactSection.vue';
import SectionHeading from '../components/SectionHeading.vue';
import {useLanguage} from '../composables/useLanguage';

const {isArabic} = useLanguage();
</script>

<template>
  <section class="page-shell">
    <div class="container page-hero">
      <SectionHeading
        align="start"
        :eyebrow="isArabic ? 'تواصل معنا' : 'Contact us'"
        :title="isArabic ? 'دعنا نحول فكرتك إلى مشروع واضح' : 'Let’s turn your idea into a clear project'"
        :description="isArabic
          ? 'أرسل لنا تفاصيل المشروع أو استفسارك، وسنعود إليك بأقرب فرصة.'
          : 'Send us your project details or any question, and we’ll get back to you as soon as possible.'"
      />
    </div>
    <ContactSection />
  </section>
</template>
